import { render, staticRenderFns } from "./Comprendre.vue?vue&type=template&id=6bac8218&scoped=true"
import script from "./Comprendre.vue?vue&type=script&lang=js"
export * from "./Comprendre.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bac8218",
  null
  
)

export default component.exports